// API Configuration
const getApiConfig = () => {
  // Check if we're in production (Docker) or development
  const isProduction =
    window.location.protocol === "https:" ||
    window.location.hostname !== "localhost";

  const protocol = isProduction ? "https:" : "http:";
  const hostname = window.location.hostname;
  const port = isProduction ? "" : ":8090";

  return {
    baseUrl: `${protocol}//${hostname}${port}`,
    apiUrl: `${protocol}//${hostname}${port}/api`,
    wsUrl: `${protocol === "https:" ? "wss:" : "ws:"}//${hostname}${port}/ws`,
    sockJsUrl: `${protocol}//${hostname}${port}/ws`,
  };
};

export const apiConfig = getApiConfig();

// Export individual URLs for convenience
export const API_BASE_URL = apiConfig.apiUrl;
export const WS_URL = apiConfig.wsUrl;
export const SOCKJS_URL = apiConfig.sockJsUrl;
export const UI_TTL_MINUTES = Number(import.meta.env.VITE_UI_TTL_MINUTES) || 10;
